import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Printer, ClipboardList } from 'lucide-react';
import { apiGet } from '../../lib/api';

export default function RouteSheet() {
  const [params] = useSearchParams();
  const [data, setData] = useState(null);
  const date = params.get('date') || new Date().toISOString().slice(0, 10);
  const routeId = params.get('route_id') || '';

  useEffect(() => {
    const qs = new URLSearchParams({ delivery_date: date });
    if (routeId) qs.set('route_id', routeId);
    apiGet(`/merchant/route-sheet?${qs.toString()}`).then(r => setData(r.data)).catch(() => {});
  }, [date, routeId]);

  return (
    <div className="min-h-screen bg-white p-6 sm:p-10 print:p-4" data-testid="route-sheet">
      <style>{`@media print { .no-print { display: none !important; } body { background: white; } }`}</style>
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-rozops-blue text-white grid place-items-center"><ClipboardList className="w-5 h-5" /></div>
            <div>
              <div className="font-heading font-extrabold text-2xl text-rozops-navy">Route Sheet</div>
              <div className="text-sm text-rozops-text-muted">Date: {date}</div>
            </div>
          </div>
          <button onClick={() => window.print()} className="no-print bg-rozops-blue text-white rounded-xl px-4 py-2 font-semibold inline-flex items-center gap-2" data-testid="print-btn"><Printer className="w-4 h-4" /> Print</button>
        </div>
        <div className="border-2 border-gray-200 rounded-2xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr className="text-left text-xs uppercase tracking-widest font-bold text-rozops-text-muted">
                <th className="py-3 px-4 w-10">#</th>
                <th className="py-3 px-4">Customer</th>
                <th className="py-3 px-4">Address · Phone</th>
                <th className="py-3 px-4">Product</th>
                <th className="py-3 px-4 text-right">Qty</th>
                <th className="py-3 px-4 w-16 text-center">Done</th>
              </tr>
            </thead>
            <tbody>
              {(data?.deliveries || []).length === 0 && <tr><td colSpan={6} className="py-8 text-center text-rozops-text-muted">No deliveries for this date.</td></tr>}
              {(data?.deliveries || []).map((d, i) => (
                <tr key={d.id} className="border-t border-gray-100">
                  <td className="py-3 px-4 font-semibold">{i + 1}</td>
                  <td className="py-3 px-4">
                    <div className="font-semibold text-rozops-navy">{d.customer?.full_name}</div>
                    {d.customer?.delivery_notes && <div className="text-xs text-rozops-text-muted italic">{d.customer.delivery_notes}</div>}
                  </td>
                  <td className="py-3 px-4 text-xs text-rozops-text-muted">
                    {d.customer?.address || '—'}<br />{d.customer?.phone || ''}
                  </td>
                  <td className="py-3 px-4">{d.product?.name}</td>
                  <td className="py-3 px-4 text-right font-bold">{d.planned_quantity} {d.product?.unit}</td>
                  <td className="py-3 px-4 text-center">
                    <div className="w-6 h-6 border-2 border-gray-300 rounded mx-auto" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-6 text-xs text-rozops-text-muted flex justify-between">
          <div>Total customers: {data?.total || 0}</div>
          <div>Delivery staff signature: ______________________</div>
        </div>
      </div>
    </div>
  );
}
